import { ITenant } from "../types";

const defaultTenant: ITenant = {
  id: "",
  name: "",
  isActive: true,
  rowVersion: "",
  companyInfo: {
    name: "",
    address: "",
    city: "",
    state: "",
    zip: "",
    country: "",
  },
  contactPerson: {
    firstName: "",
    lastName: "",
    jobTitle: "",
    email: "",
    phone: "",
    phoneExtension: "",
    mobilePhone: "",
  },
};

export default defaultTenant;
